import { get } from 'axios'

function doFetch() {
  if (!process.env.VUE_APP_SERVICE_STATUS_URL) {
    // 稼働状況取得URLが設定されていない場合はサービス開始、終了時間を入れずに返す。
    return Promise.resolve({})
  } else {
    return get(process.env.VUE_APP_SERVICE_STATUS_URL).then(r => r.data)
  }
}

/**
 * 現在のサービス稼働状況を取得する
 */
export function fetchCurrentStatus() {
  return doFetch()
}
